import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./top-progress-bar.css";

function TopProgressBar() {
  const location = useLocation();
  const [width,   setWidth]   = useState(0);
  const [opacity, setOpacity] = useState(0);
  const timers = useRef<ReturnType<typeof setTimeout>[]>([]);

  const clearAll = () => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
  };

  useEffect(() => {
    clearAll();

    // Reset instantly (no CSS transition while width is 0)
    setWidth(0);
    setOpacity(1);

    const add = (fn: () => void, ms: number) => {
      const t = setTimeout(fn, ms);
      timers.current.push(t);
    };

    add(() => setWidth(25),  30);   // fast jump to 25%
    add(() => setWidth(60),  180);  // ease to 60%
    add(() => setWidth(80),  500);  // slow crawl to 80%
    add(() => setWidth(95),  900);  // near-complete
    add(() => setWidth(100), 1300); // done
    add(() => setOpacity(0), 1500); // fade out
    add(() => {                     // cleanup
      setWidth(0);
      setOpacity(0);
    }, 1800);

    return clearAll;
  }, [location.key]);

  // Don't render until first navigation fires
  if (opacity === 0 && width === 0) return null;

  return (
    <div
      className="top-progress-bar"
      style={{
        width:      `${width}%`,
        opacity,
        transition: width === 0
          ? "none"
          : "width 0.35s ease, opacity 0.25s ease",
      }}
    />
  );
}

export default TopProgressBar;
